import ExpandedSocialProofSection from "@/components/equinox/ExpandedSocialProofSection";
import { useOutletContext } from "react-router-dom";
import GrowthOsPreviewSection from "@/components/equinox/GrowthOsPreviewSection";
import HeroSection from "@/components/equinox/HeroSection";
import ProofBar from "@/components/equinox/ProofBar";
import SystemsAndProofSection from "@/components/equinox/SystemsAndProofSection";
import TrustedBySection from "@/components/equinox/TrustedBySection";

export default function HomePage() {
  const { onPrimaryAction } = useOutletContext();

  return (
    <>
      <HeroSection />
      <ExpandedSocialProofSection />
      <ProofBar />
      <GrowthOsPreviewSection onOpenChatbot={onPrimaryAction} />
      <TrustedBySection />
      <SystemsAndProofSection onOpenChatbot={onPrimaryAction} />
    </>
  );
}